// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SaveIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SaveIcon" ref={forwardedRef} {...props}>
      <path d="M12 6H7v1.5h5z" />
      <path d="M3.996 17h12a1 1 0 0 0 1-1L17 7.415a1 1 0 0 0-.294-.708l-1.702-1.7-1.711-1.714A1 1 0 0 0 12.585 3H3.996a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1m9.946-10.934L15.5 7.622 15.497 15.5h-1.999V10h-7v5.5H4.496v-11h7.882zM11.998 15.5h-4v-4h4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SaveIcon = /* @__PURE__ */ Object.assign(SaveIconComponent, {
  displayName: 'SaveIcon',
});
